import { render } from "./ReserveInfoDetail_nMem.vue?vue&type=template&id=73a88022&scoped=true"
import script from "./ReserveInfoDetail_nMem.vue?vue&type=script&lang=js"
export * from "./ReserveInfoDetail_nMem.vue?vue&type=script&lang=js"

import "./ReserveInfoDetail_nMem.vue?vue&type=style&index=0&id=73a88022&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a88022"]])

export default __exports__